import { lazy, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router";
import { Toaster } from "sonner";

import { AdminLayout } from "./components/layout/AdminLayout";
import { RequireAdmin } from "./components/RequireAdmin";

const Login = lazy(() => import("./pages/Login"));
const AdminDashboard = lazy(() => import("./pages/admin/AdminDashboard"));
const AdminUsers = lazy(() => import("./pages/admin/AdminUsers"));
const AdminUserDetail = lazy(() => import("./pages/admin/AdminUserDetail"));
const AdminApps = lazy(() => import("./pages/admin/AdminApps"));
const AdminAI = lazy(() => import("./pages/admin/AdminAI"));
const AdminWaitlist = lazy(() => import("./pages/admin/AdminWaitlist"));
const AdminExploreTemplates = lazy(
  () => import("./pages/admin/AdminExploreTemplates"),
);

function App() {
  return (
    <>
      <Suspense fallback={<div className="p-8">Loading…</div>}>
        <Routes>
          <Route path="/" element={<Navigate to="/admin" replace />} />
          <Route path="/login" element={<Login />} />
          <Route
            path="/admin"
            element={
              <RequireAdmin>
                <AdminLayout />
              </RequireAdmin>
            }
          >
            <Route index element={<AdminDashboard />} />
            <Route path="users" element={<AdminUsers />} />
            <Route path="users/:id" element={<AdminUserDetail />} />
            <Route path="apps" element={<AdminApps />} />
            <Route path="ai" element={<AdminAI />} />
            <Route
              path="explore-templates"
              element={<AdminExploreTemplates />}
            />
            <Route path="waitlist" element={<AdminWaitlist />} />
          </Route>
          <Route path="*" element={<Navigate to="/admin" replace />} />
        </Routes>
      </Suspense>
      <Toaster />
    </>
  );
}

export default App;
